import { defineStore } from "pinia";

export const useEventCategoryStore = defineStore("eventCategoryStore", () => {

  const events = ref([]);

  const categories = ref([]);


  const router = useRouter();

  function initEvents(data) {
    events.value = data;
  }
  function initEventCategories(data) {
    categories.value = data;
  }
  function addNewEvent(event) {
    events.value.push(event);
  }

  async function getEventCategories() {
    try {
      const data = await useNuxtApp().$apiAuth(`/api/event/category/get/all`,{
        method: 'GET',
        use: 'admin'
       })

        return {
          success: true,
          data: data?.data,
        };
      
    } catch (error) {

      return {
        success: false,
        status: error.response?.status,
        data: null,
      };
    }
   
  }
  async function getEventPaginate(filter) {
    try {
      const data = await useNuxtApp().$apiAuth(`/api/event/category/paginate`,{
        method: 'GET',
        use: 'admin',
        params:{
        ...filter
        }
       })
  
        return {
          success: true,
          data: data?.data,
        };
      
    } catch (error) {

      return {
        success: false,
        status: error.response?.status,
        data: null,
      };
    }
   
  }
  async function createEventCategory(
    input
  ) {
    try {
      const data = await useNuxtApp().$apiAuth(`/api/event/category/create`,{
        method: 'POST',
        use: 'admin',
        body:{
          ...input
        }
       })    
        return {
          success: true,
          data: data?.data,
          errorValidation: {}
        };
      
    } catch (error) {
       
      return {
        success: false,
        status: error.response?.status,
        data: null,
        errorValidation: error?.response?._data?.errors
     
      };
    }
    
  }

  async function deleteEventCategory(id) {
    try {
      const data = await useNuxtApp().$apiAuth(`/api/event/category/delete/${id}`,{
        method: 'DELETE',   
        use: 'admin',   
       })
    
        return {
          success: true,
          data: data?.data,
        };
      
    } catch (error) {
     
      
      return {
        success: false,
        status: error.response?.status,
        data: null,
        errorValidation: error?.response?.data?.errors
      };
    }
    
  }

  async function updateEventCategory(
    input
  ) {
    try {
      const data = await useNuxtApp().$apiAuth(`/api/event/category/update`,{
        method: 'PUT',
        use: 'admin',
        body:{
          ...input
        }
       })
            
        return {
          success: data?.success,
          data: data?.data,
          errorValidation: {}
        };
      
    } catch (error) {

      return {
        success: false,
        status: error.response?.status,
        data: null,
        errorValidation: error?.response?._data?.errors
      };
    }
   
  }
  async function setEventCategoryCache() {
    try {
      const data = await useNuxtApp().$apiAuth(`/api/event/category/cache/set`,{
        method: 'GET',
        use: 'admin'
       })
  
                               
        return {
          success: data?.success,
          data: data?.data,
        };
      
    } catch (error) {

      return {
        success: false,
        status: error.response?.status,
        data: null,
      };
    }
  }
  async function getEventCategoryCache() {
    try {
      const data = await useNuxtApp().$api(`/api/event/category/cache/get`,{
        method: 'GET',
        use: 'admin'
       })
  
        return {
          success: true,
          data: data?.data,
        };
      
    } catch (error) {
 
      return {
        success: false,
        status: error.response?.status,
        data: null,
      };
    }
  }
  async function setEventWhenCategoryCache() {
    try {
      const data = await useNuxtApp().$apiAuth(`/api/event/category/when/cache/set`,{
        method: 'GET',
        use: 'admin'
       })
                         
        return {
          success: data?.success,
          data: data?.data,
        };
      
    } catch (error) {

      return {
        success: false,
        status: error.response?.status,
        content: null,
      };
    }
  }
  async function getEventWhenCategoryCache() {
    try {
      const data = await useNuxtApp().$apiAuth(`/api/event/category/when/cache/get`,{
        method: 'GET',
        use: 'admin'
       })
     
         
        return {
          success: true,
          data: data?.data,
        };
      
    } catch (error) {

      return {
        success: false,
        status: error.response?.status,
        data: null,
      };
    }
  }
  return {
    categories,
    getEventCategories,
    createEventCategory,
    updateEventCategory,
    deleteEventCategory,
    getEventPaginate,
    setEventCategoryCache,
    getEventCategoryCache,
    setEventWhenCategoryCache,
    getEventWhenCategoryCache
  };
});
